import router from '@/router/index.js'
import cookie from 'js-cookie'
export default function quit() {
    cookie.remove('openId')
    cookie.remove('id')
    cookie.remove('fullName')
    cookie.remove('username')
    cookie.remove('showPrompt')
    cookie.remove('stationId')
    cookie.remove('stationName')
    cookie.remove('tempTabLabel')
    cookie.remove('stationDirector')
    cookie.remove('hadDirector')
    sessionStorage.clear()
    router.replace(`/login`)
    // window.location.reload();
}


// WEBPACK FOOTER //
// ./src/common/quit.js